import * as React from 'react';

import * as styles from './Anonymous.css';

export const Anonymous = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className={styles['container']}>{children}</div>;
};
